// src/components/modals/PartidoDetalleModal.jsx
//
// Wrapper modal para DetailPanel. Reemplaza el patrón anterior donde
// DetailPanel se renderizaba inline debajo del row (tabla expandible)
// — eso rompía el flujo visual de la tabla y obligaba a hacer scroll
// sobre filas previas para volver al partido seleccionado.
//
// Ahora el click en un row abre este modal flotante centrado, mantiene
// la tabla intacta detrás, y se cierra con ESC, X o click en backdrop.
// createPortal a document.body para que el modal escape de overflows
// del padre (sticky-cta, sidebar, etc.).
//
// El sistema de banner de ligas (recomendada / semi / no recomendada)
// queda para una iteración futura — este modal solo encapsula el
// DetailPanel existente sin cambiar su contenido interno.

import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import DetailPanel from '../DetailPanel';
import '../../styles/partido-modal.css';

const I = ({ children, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round">{children}</svg>
);
const IconClose = () => <I><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></I>;

export default function PartidoDetalleModal({ pick, onClose, lineOverride }) {
  useEffect(() => {
    if (!pick) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [pick, onClose]);

  if (!pick) return null;

  return createPortal(
    <div
      className="pm-backdrop"
      onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
      role="dialog"
      aria-modal="true"
      aria-label={`Detalle del partido ${pick.partido || ''}`}
    >
      <div
        className="pm-modal"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="pm-close"
          onClick={onClose}
          aria-label="Cerrar"
          title="Cerrar"
        >
          <IconClose />
        </button>
        {/* DetailPanel sin `inline`: usa su layout normal (con breadcrumb
            interno, summary, cards). El "Cerrar ×" del breadcrumb interno
            queda oculto por el CSS .pm-modal .md-breadcrumb .close-x. */}
        <DetailPanel pick={pick} onClose={onClose} lineOverride={lineOverride} />
      </div>
    </div>,
    document.body
  );
}
